import { Emitter } from '../panel/utils/emitter';

const appEvents = new Emitter();

export default appEvents;
